<template>
  
  <el-dialog  :visible.sync="dialogVisibleok"  title="放款确认" :close-on-click-modal="false" :close-on-press-escape="false">

    <el-form :model="dataForm"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <h3>债权转让方</h3>
      <el-form-item label="ACCP账号" prop="custName">
          <el-input v-model="dataForm.custName" disabled ></el-input>
      </el-form-item>
      <el-form-item label="系统ID" prop="mobile">
          <el-input v-model="dataForm.mobile" disabled ></el-input>
      </el-form-item>
      <el-form-item label="ACCP银行卡号" prop="idNo">
          <el-input v-model="dataForm.idNo" disabled ></el-input>
      </el-form-item>
          
      <el-form-item label="交易用途" prop="registerProvinceCode">
          <el-input v-model="dataForm.registerProvinceCode" disabled ></el-input>
      </el-form-item> 

      <el-form-item label="放款金额" prop="registerProvinceCode">
          <el-input v-model="dataForm.registerProvinceCode" disabled ></el-input>
      </el-form-item>
      <el-form-item label="手续费" prop="registerProvinceCode">
          <el-input v-model="dataForm.registerProvinceCode" disabled ></el-input>
      </el-form-item>
      <el-form-item label="总金额" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>
      <el-form-item label="账户余额" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>
    
      <h3>原始债权人</h3>

      <el-form-item label="ACCP账户" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>
      <el-form-item label="ACCP银行卡号" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>
      <el-form-item label="放款总金额" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>

      <h3>收款方 7*24小时到账</h3>

      <el-form-item label="银行卡号" prop="registerProvinceCode">
          <el-input v-model="dataForm.borrowType" disabled ></el-input>
      </el-form-item>
      
      <el-form-item label="开户名" prop="bankCardNo">
          <el-input v-model="dataForm.bankCardNo" disabled></el-input>
      </el-form-item>

      <el-form-item label="合同和申请书" prop="bankCardNo">
        <div class="compact">
            <div @click="compact('shen')">借款申请书</div>
            <div @click="compact('he')">借款合同</div>
        </div>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="dialogVisibleok = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="loanIsOk()" >{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisibleok:false,
      date:'',
      gjr:false,
      dataForm: {
        // my
        dwellValue:'',
        houseValue:'',
        unitValue:'',
        borrowValue:'',
        borrowType:'',
        startDate:'',
        endDate:'',
        time:'',
        id: '',
        custCode: '',
        custName: '',
        mobile: '',
        idType: '',
        idNo: '',
        sex: '',
        birthday: '',
        registerProvinceCode: '',
        registerCityCode: '',
        registerAreaCode: '',
        registerAddress: '',
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        address: '',
        isMarriedCode: '',
        educationCode: '',
        companyType: '',
        carStatus: '',
        houseStatus: '',
        bankCode: '',
        bankName: '',
        bankCardNo: '',
        email: '',
        createTime: '',
        createBy: '',
        updateTime: '',
        updateBy: '',
        version: '',
        remark: ''
      }
    }
  },
  methods: {
    // 页面跳转
    compact(r){
      const routeUrl = this.$router.resolve({
          path: "/loanok",
        
          query: { id: 96 },
          });

      window.open(routeUrl.href, "_blank");
      //  this.$router.push({
      //   name:'loanok',
      //   query:{
      //     r
      //   }
      //  })
    },
    // 放款确认
    loanIsOk(){
      console.log(13123)
      this.dialogVisibleok = false
      this.$emit('iscodeFS')
    }

  },
}
</script>

<style lang="scss" scoped>
 .tj{
  border: 1px solid #ccc;
 }
 .gjr{
  border: 1px solid red;
 }
 .ht{
  display: flex;
  justify-content: space-between;
 }
 .compact{
   display: flex;
   color: blue;
   justify-content: space-between;
 }
 
</style>
